/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable jsx-a11y/label-has-associated-control */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useUser, useSetUser } from '../../contexts/AuthContext';
import DeleteProfileForm from '../forms/DeleteProfile';
import MainLayout from '../layouts/Main';
import UserPlaceholder from '../partials/UserPlaceholder';
import UserSidebar from '../partials/UserSidebar';

import styles from '../../../styles/pages/account.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ProfileDeletePage = ({ className }) => {
    const { locale } = useIntl();

    const user = useUser();
    const setUser = useSetUser();
    const onUserDeleted = useCallback(() => {
        setUser(null);
        window.location.href = `/${locale}?deleted=1`;
    }, [setUser, locale]);

    return (
        <MainLayout>
            <div
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <div className={styles.inner}>
                    {user === null ? (
                        <UserPlaceholder className={styles.placeholder} />
                    ) : (
                        <>
                            <UserSidebar user={user} className={styles.sidebar} />
                            <div className={styles.main}>
                                <div className={styles.content}>
                                    <h2 className={styles.title}>
                                        <FormattedMessage
                                            defaultMessage="Delete your profile"
                                            description="Section title"
                                        />
                                    </h2>
                                    <p className={styles.warning}>
                                        <FormattedMessage
                                            defaultMessage="Are you sure you want to delete your profile, your favorites and all the related information? This action cannot be undone."
                                            description="Description"
                                        />
                                    </p>
                                    <p className={styles.warning}>
                                        <FormattedMessage
                                            defaultMessage="If this is the case, please type your email to confirm and press the 'Delete my profile' button."
                                            description="Description"
                                        />
                                    </p>
                                    <DeleteProfileForm onComplete={onUserDeleted} />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </MainLayout>
    );
};

ProfileDeletePage.propTypes = propTypes;
ProfileDeletePage.defaultProps = defaultProps;

export default ProfileDeletePage;
